import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="810588910924-hv03dc0c3n7ckcs94orgtrrud0equkfm.apps.googleusercontent.com">
    <App />
  </GoogleOAuthProvider>
);

